function getPdfHref(mark) {
  return mark && mark.pdf && mark.pdf.asset && mark.pdf.asset.url
    ? mark.pdf.asset.url
    : null;
}

module.exports = { getPdfHref };
